function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m61.333 42.667a2.6667 2.6667 0 0 0-2.6667 2.6667v10.667a2.6667 2.6667 0 0 1-2.6667 2.6667h-48a2.6667 2.6667 0 0 1-2.6667-2.6667v-10.667a2.6667 2.6667 0 0 0-2.6667-2.6667 2.6667 2.6667 0 0 0-2.6667 2.6667v10.667a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-10.667a2.6667 2.6667 0 0 0-2.6667-2.6667z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6667
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.115 36.101 12.229 12.232a8.0187 8.0187 0 0 0 11.312 0l12.229-12.229a2.6667 2.6667 0 1 0-3.7707-3.7707l-11.448 11.443v-41.109a2.6667 2.6667 0 0 0-5.3333 0v41.112l-11.448-11.448a2.6667 2.6667 0 1 0-3.7707 3.7707z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6667
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4bf29f23.svg";
export { ForwardRef as ReactComponent };